<template>
  <div class="col-md-12 p-0 attendance-detail-page">
    <!-- Download / export excel -->
    <div class="popup popup-sm attendance-modal" v-if="isEnablePopup == 'download'">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <h5 class="text-left">
          {{ download.title }}<br />
          <span class="text-secondary mr-4"
            >Please choose available file report format to download.</span
          >
          <hr />
        </h5>
        <div class="text-right">
          <export-excel
            class="float-right mr-2"
            :data="download.data"
            :fields="download.fields"
            type="csv"
            :name="download.name"
            :title="download.title"
          >
            <a href="javascript:;" class="btn btn-light"
              ><i class="ti ti-file text-warning"></i> Format .CSV</a
            >
          </export-excel>
          <export-excel
            class="float-right mr-2"
            :data="download.data"
            :fields="download.fields"
            type="xls"
            :name="download.name"
            :title="download.title"
          >
            <a href="javascript:;" class="btn btn-light"
              ><i class="ti ti-file text-success"></i> Format .XLS</a
            >
          </export-excel>
        </div>
      </div>
    </div>
    <!-- ==================== -->

    <!-- Download / export excel -->
    <div class="popup popup-sm attendance-modal" v-if="isEnablePopup == 'download_by_date'">
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <div class="row">
          <div class="col-md-12 text-center">
            <h5 align="center">
              Please choose date range file report format to download.
            </h5>
            <img
              class="img-rounded text-center mt-3"
              :src="'img/uploadfile.png'"
              title="Upload Excel"
            />
          </div>
          <div class="col-md-12 mt-4">
            <date-picker
              v-model="period_contract"
              :disabled-date="disabledBeforeAfterPeriodContract"
              value-type="format"
              type="date"
              format="YYYY-MM-DD"
              placeholder="Choose Date Range"
              width="100%"
              style="width: 100%"
              range
            >
            </date-picker>
          </div>
        </div>
        <div class="text-right mt-3">
          <a
            v-if="period_contract.length > 0"
            @click="downloadExcelContractByDate($event)"
            class="btn btn-success"
            ><i class="ti ti-file text-light"></i> Format .XLS</a
          >
        </div>
      </div>
    </div>
    <!-- ==================== -->

    <!-- Download / export excel -->
    <div
      class="popup popup-sm attendance-modal"
      v-if="isEnablePopup == 'download_by_date_contract'"
    >
      <div class="content">
        <small id="close-popup" @click="isEnablePopup = false"
          ><i class="ti ti-close"></i
        ></small>
        <div class="row">
          <div class="col-md-12 text-center">
            <h5 align="center">
              Pilih Periode tanggal untuk melihat Report Absen
            </h5>
            <img
              class="img-rounded text-center mt-3"
              :src="'img/uploadfile.png'"
              title="Upload Excel"
            />
          </div>
          <div class="col-md-12 mt-4">
            <date-picker
              v-model="period_contract"
              :disabled-date="disabledBeforeAfterPeriodContract"
              value-type="format"
              type="date"
              format="YYYY-MM-DD"
              placeholder="Choose Date Range"
              width="100%"
              style="width: 100%"
              range
            >
            </date-picker>
          </div>
        </div>
        <div class="text-right mt-3">
          <a
            v-if="period_contract.length > 0"
            @click="downloadExcelContractByDate2($event)"
            class="btn btn-success"
            ><i class="ti ti-file text-light"></i> Format .XLS</a
          >
        </div>
      </div>
    </div>
    <!-- ==================== -->

    <!-- Modal Preview Photo -->
    <div v-if="previewImage" class="popup popup-md attendance-modal attendance-photo-modal">
      <div class="content text-center">
        <small id="close-popup" @click="previewImage = null">
          <i class="ti ti-close"></i>
        </small>

        <h5>Preview Attendance Photo</h5>
        <hr />

        <img :src="previewImage" class="img-fluid" style="max-height: 500px" />
      </div>
    </div>

    <section class="attendance-detail-hero">
      <div>
        <span class="attendance-detail-hero__eyebrow">ATTENDANCE REPORT</span>
        <h2>Attendance Detail</h2>
        <p>Monitor kehadiran, shift, jam masuk, dan jam keluar employee.</p>
      </div>
      <router-link :to="{ name: 'report/attendance-data' }" class="attendance-back-btn">
        <i class="ti ti-arrow-left"></i> Back to Attendance
      </router-link>
    </section>

    <div class="card attendance-detail-card">
      <div class="card-body" v-if="!isLoading">
        <div class="contract-summary">
          <div class="row">
            <div class="col-md-7 contract-client">
              <ListLoader
                v-if="$store.state.loading.status"
                :speed="1"
                primaryColor="#f3f3f3"
                secondaryColor="#ecebeb"
              ></ListLoader>
              <div v-else>
                <span class="contract-summary__label">CLIENT INFORMATION</span>
                <h4>{{ model_contract.client_name }}</h4>
                <p class="contract-contact">
                  <span><i class="ti ti-email"></i> {{ model_contract.email }}</span
                  ><span><i class="ti ti-mobile"></i> {{
                    model_contract.phone_number | formatPhone
                  }}</span>
                </p>
                <p class="contract-address">
                  <i class="ti ti-location-pin"></i>
                  <span>{{ model_contract.office_address }} <br />
                  {{ model_contract.nama_provinsi }},
                  {{ model_contract.nama_kota }}</span>
                </p>
              </div>
            </div>
            <div class="col-md-5 contract-facts">
              <ul class="list-area" v-if="$store.state.loading.status">
                <li>
                  <ListLoader
                    :speed="1"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                  ></ListLoader>
                </li>
              </ul>
              <ul class="list-area" v-else>
                <li>
                  <span>Contract Number</span>
                  <strong># {{ model_contract.contract_number }}</strong>
                </li>
                <li>
                  <span>Contract Period</span>
                  <strong>{{ model_contract.start_date | moment("DD/MM/YYYY") }} -
                    {{ model_contract.end_date | moment("DD/MM/YYYY") }}</strong>
                </li>
                <li v-if="model_contract.man_power !== undefined">
                  <span>MP Request</span>
                  <div class="manpower-list">
                  <span
                    v-for="(initems, index) in JSON.parse(
                      model_contract.man_power
                    )"
                    :key="index"
                  >
                    {{ initems.total }} ( {{ initems.job }} )
                  </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="attendance-toolbar">
          <div class="attendance-toolbar__heading">
              <label
                ><i class="ti ti-info-alt"></i> Employee Attendance</label
              >
              <small
                >P( Shift Pagi ), S (Shift Siang), M (Shift Malam)</small
              >
          </div>
          <div class="attendance-toolbar__actions">
              <a
                @click="modalExportContractAbsen()"
                class="btn btn-success"
              >
                <i class="ti ti-cloud-down"></i> Download Report Absen
              </a>

              <a @click="modalExportContract()" class="btn btn-primary">
                <i class="ti ti-cloud-down"></i> Download Data
              </a>

              <!-- modify rudy -->
              <!--<select class="form-control" v-model="filter_date"  @change="FilterModelDate()" style="width:200px;">
                                <option v-for="(items, index) in collection_period" :key="index" :value="items" >{{ items }}</option>
                            </select> -->
              <date-picker
                class="attendance-month-picker"
                v-model="filter_date"
                :default-value="filter_date"
                :disabled-date="disabledBeforeAfterFilterDate"
                :clearable="false"
                value-type="format"
                type="month"
                format="MM/YYYY"
                placeholder="Pilih Range Tanggal"
                width="100%"
                @change="FilterModelDate()"
                confirm
              >
              </date-picker>
          </div>
        </div>
        <div class="attendance-matrix" v-if="model_date_range.length > 0">
          <div class="attendance-date-column">
            <div class="table-cover attendance-table-cover">
              <table class="table-hover xo">
                <thead>
                  <!-- rowspan='2' height="65" -->
                  <tr rowspan="2">
                    <th class="text-center no-filter attendance-date-title" style="height: 66px">
                      <small
                        ><b class="text-danger">Officer Attendance</b></small
                      >
                    </th>
                  </tr>
                  <!-- <tr >
                                        <th class="text-center no-filter" style="height:33px">&nbsp;</th>
                                    </tr> -->
                  <tr>
                    <th class="text-center no-filter" style="height: 33px">
                      Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(items, index) in model_date_range"
                    :key="index"
                    :class="'trdate ' + items.month + '-' + items.year"
                  >
                    <!-- disable class tdp -->
                    <td class="tdp" style="height: 70px">
                      <span
                        :class="items.name_of_day == 'Sun' ? 'text-danger' : ''"
                        >{{ items.name_of_day }}</span
                      ><br />
                      <small class="text-secondary">{{
                        items.day + "/" + items.month + "/" + items.year
                      }}</small>
                    </td>
                  </tr>
                  <tr rowspan="2">
                    <td class=""><b>Total Attendance</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="attendance-employee-grid">
            <div class="table-cover attendance-table-cover">
              <!-- :style="'min-width:'+table_cover_width+'px;'" disable sementara -->
              <table
                class="table-hover xo"
                :style="'min-width:' + table_cover_width + 'px;'"
              >
                <thead>
                  <tr style="height: 33px">
                    <th
                      class="text-center no-filter"
                      v-for="(items, idx) in model_group_employee"
                      :key="idx"
                      style="position: relative"
                      colspan="2"
                    >
                      <a
                        href="javascript:;"
                        class="employee-download"
                        @click="
                          DownloadData(
                            GetDataSplitEmployee('nik', idx),
                            GetDataSplitEmployee('name', idx)
                          )
                        "
                        ><i class="ti-cloud-down"></i> Download</a
                      >
                    </th>
                  </tr>
                  <tr style="height: 33px">
                    <th
                      class="text-center no-filter"
                      v-for="(items, idx) in model_group_employee"
                      :key="idx"
                      style="position: relative"
                      colspan="2"
                    >
                      <a
                        href="javascript:;"
                        :title="GetDataSplitEmployee('name', idx)"
                      >
                        <span class="employee-name">
                          {{
                            GetDataSplitEmployee("name", idx)
                              | limit(15, " ...")
                          }}
                        </span>
                      </a>
                    </th>
                  </tr>
                  <tr style="height: 33px">
                    <th
                      class="text-center no-filter"
                      v-for="(items, idx) in total_employee * 2"
                      :key="idx"
                      style="position: relative"
                    >
                      <span
                        :class="
                          InitialInOut(idx) == 'IN'
                            ? 'text-success'
                            : 'text-danger'
                        "
                        >{{ InitialInOut(idx) }}</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(items_date, idx) in model_date_range"
                    :key="idx"
                    :class="
                      'trdate ' + items_date.month + '-' + items_date.year
                    "
                  >
                    <!-- disable class tdp -->
                    <td
                      class="tdp"
                      v-for="(items, idx) in model_inout"
                      :key="idx"
                      style="height: 70px"
                    >
                      <span
                        style="cursor: pointer"
                        @click="
                          openPhoto(
                            items.index,
                            items.res,
                            items_date.day +
                              '-' +
                              items_date.month +
                              '-' +
                              items_date.year
                          )
                        "
                      >
                        <i class="ti-camera ml-1 attendance-camera"></i>
                        Shift -
                        {{
                          GetAttendanceInOut(
                            items.index,
                            "shift",
                            items_date.day +
                              "-" +
                              items_date.month +
                              "-" +
                              items_date.year
                          )
                        }}</span
                      ><br />
                      <span
                        :class="
                          items.res == 'in' ? 'text-success' : 'text-danger'
                        "
                        >{{
                          GetAttendanceInOut(
                            items.index,
                            items.res,
                            items_date.day +
                              "-" +
                              items_date.month +
                              "-" +
                              items_date.year
                          )
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-center"
                      v-for="(items, idx) in model_inout"
                      :key="idx"
                      v-if="items.res == 'in'"
                      colspan="2"
                    >
                      <span class="badge badge-success"
                        >{{ GetTotalAttendanceIn(items.index) }} Days</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="attendance-empty" v-else>
          <div>
            <i class="ti ti-info-alt"></i>
            <strong>Attendance data is empty</strong>
            <span>Please manage the contract shift work before viewing attendance.</span>
          </div>
        </div>
      </div>
      <div class="card-body" v-else>
        <div class="row">
          <div class="col-md-6">
            <ListLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            ></ListLoader>
          </div>
          <div class="col-md-6">
            <ListLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            ></ListLoader>
          </div>
          <div class="col-md-12">
            <ContentLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="0" y="0" rx="2" ry="2" width="400" height="250" />
            </ContentLoader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

import { ContentLoader, ListLoader, CodeLoader } from "vue-content-loader";
import axios from "axios";

export default {
  components: {
    ContentLoader,
    ListLoader,
    CodeLoader,
    DatePicker,
  },
  data() {
    return {
      previewImage: null,
      isLoading: true,
      isEnablePopup: false,
      table_cover_width: 0,
      model_contract: {},
      model_group_employee: [],
      model_date_range: [],
      model_inout: [],
      total_employee: 0,
      collection_period: [],
      filter_shift: "all",
      period_contract: [],
      // filter date
      filter_date: "",
      filter_year: "",
      filter_month: "",
      download: { fields: "", data: "", title: "", name: "" },
      download_by_date: { fields: "", data: "", title: "", name: "" },
      download_by_date_contract: { fields: "", data: "", title: "", name: "" },
    };
  },
  mounted() {
    this.QueryStartFromPeriod();
  },
  methods: {
    disabledBeforeAfterPeriodContract(date) {
      // console.log(this.model_contract);
      const start_date = new Date(this.model_contract.start_date);
      start_date.setHours(0, 0, 0, 0);

      const end_date = new Date(this.model_contract.end_date);
      end_date.setHours(0, 0, 0, 0);

      return date < start_date || date > end_date;
    },
    disabledBeforeAfterFilterDate(date) {
      const start_date = new Date(this.model_contract.start_date);
      start_date.setHours(0, 0, 0, 0);

      const end_date = new Date(this.model_contract.end_date);
      end_date.setHours(0, 0, 0, 0);

      let dateNow = new Date(date.getFullYear(), date.getMonth());
      let dateStart = new Date(start_date.getFullYear(), start_date.getMonth());
      let dateEnd = new Date(end_date.getFullYear(), end_date.getMonth());

      return dateNow < dateStart || dateNow > dateEnd;
    },
    modalExportContract() {
      this.download_by_date.title = "Report Attendace By Date Range";
      this.isEnablePopup = "download_by_date";
    },
    modalExportContractAbsen() {
      this.download_by_date.title = "Report Attendace By Date Range";
      this.isEnablePopup = "download_by_date_contract";
    },
    async downloadExcelContractByDate(event) {
      event.target.className = "btn btn-success disabled";
      this.$store.state.loading.msg =
        "Download Report Data Period " +
        this.period_contract[0] +
        " until " +
        this.period_contract[1];
      this.$store.state.loading.status = true;

      this.period_contract = [this.period_contract[0], this.period_contract[1]];

      let dataParams = {
        id_contract: localStorage.getItem("QUERY_ID"),
        start_date: this.period_contract[0],
        end_date: this.period_contract[1],
      };

      await axios
        .post("report/attendance-contract-download", dataParams, {
          responseType: "blob",
        })
        .then((res) => {
          // console.log(res);
          const link = document.createElement("a");

          link.href = window.URL.createObjectURL(new Blob([res.data]));

          link.setAttribute(
            "download",
            "Report Attendace " +
              this.model_contract.client_name +
              " Period " +
              this.period_contract[0] +
              " until " +
              this.period_contract[1] +
              ".xlsx"
          );

          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.$store.state.loading.status = false;
          event.target.className = "btn btn-success";
          this.isEnablePopup = false;
        });
    },
    async downloadExcelContractByDate2(event) {
      event.target.className = "btn btn-success disabled";
      this.$store.state.loading.msg =
        "Download Report Absensi Data Period " +
        this.period_contract[0] +
        " until " +
        this.period_contract[1];
      this.$store.state.loading.status = true;

      this.period_contract = [this.period_contract[0], this.period_contract[1]];

      let dataParams = {
        id_contract: localStorage.getItem("QUERY_ID"),
        start_date: this.period_contract[0],
        end_date: this.period_contract[1],
      };

      await axios
        .post("report/attendance-contract-period-download", dataParams, {
          responseType: "blob",
        })
        .then((res) => {
          // console.log(res);
          const link = document.createElement("a");

          link.href = window.URL.createObjectURL(new Blob([res.data]));

          link.setAttribute(
            "download",
            "Report Absensi " +
              this.model_contract.client_name +
              " Period " +
              this.period_contract[0] +
              " until " +
              this.period_contract[1] +
              ".xlsx"
          );

          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.$store.state.loading.status = false;
          event.target.className = "btn btn-success";
          this.isEnablePopup = false;
        });
    },
    DownloadData(nik, name) {
      this.$store.state.loading.msg = "Download Report Data...";
      this.$store.state.loading.status = true;
      axios
        .post("report/attendance-download", {
          id_contract: localStorage.getItem("QUERY_ID"),
          month: this.filter_month,
          year: this.filter_year,
          nik: nik,
        })
        .then((res) => {
          this.download.fields = { Date: "date", In: "in", Out: "out" };
          this.download.title = "Report Attendace - " + name;
          this.download.name = name + ".xls";
          this.download.data = res.data;
          this.isEnablePopup = "download";
        })
        .finally(() => {
          this.$store.state.loading.status = false;
        });
    },

    InitialInOut(index) {
      return index % 2 == 0 ? "IN" : "OUT";
    },

    GetDataSplitEmployee(initial, data) {
      let data_split = data.split("-");

      if (initial == "nik") {
        return data_split[0];
      }

      if (initial == "name") {
        return data_split[1];
      }
    },

    GetAttendanceInOut(index, initial, date) {
      let model = this.model_group_employee[index];
      for (let key in model) {
        var dt =
          model[key].day + "-" + model[key].month + "-" + model[key].year;
        if (dt == date && initial == "in") {
          return model[key].in;
        }

        if (dt == date && initial == "out") {
          return model[key].out;
        }

        if (dt == date && initial == "shift") {
          return model[key].shift;
        }
      }
    },
    openPhoto(index, type, date) {
      let data = this.GetAttendanceData(index, date);

      if (!data) return;

      if (type === "in" && data.photo_in) {
        this.previewImage = data.photo_in;
      } else if (type === "out" && data.photo_out) {
        this.previewImage = data.photo_out;
      } else {
        alert("Photo tidak tersedia");
      }
    },
    GetAttendanceData(index, date) {
      let model = this.model_group_employee[index];

      for (let key in model) {
        var dt =
          model[key].day + "-" + model[key].month + "-" + model[key].year;

        if (dt == date) {
          return model[key];
        }
      }

      return null;
    },
    GetTotalAttendanceIn(index) {
      var total = 0;
      let model = this.model_group_employee[index];
      for (let key in model) {
        if (model[key].in !== "00:00:00") {
          total++;
        }
      }
      return total;
    },

    FilterModelDate() {
      let fdate = this.filter_date.split("/");
      this.filter_month = fdate[0];
      this.filter_year = fdate[1];
      this.DataQuery();
    },

    async QueryStartFromPeriod() {
      await axios
        .get("contract/period/" + localStorage.getItem("QUERY_ID"))
        .then((response) => {
          const d = new Date();
          let query = response.data;
          let default_date = query.default;
          // var dt = default_date.split('/');

          this.collection_period = query.month_period;
          // this.filter_month = dt[0];
          // this.filter_year  = dt[1];
          this.filter_month = ("0" + (d.getMonth() + 1)).slice(-2);
          this.filter_year = d.getFullYear().toString();

          this.filter_date = this.filter_month + "/" + this.filter_year;

          // this.filter_date  = default_date;

          this.DataQuery();
        })
        .catch((error) => {
          console.log(error.statusText);
        })
        .finally(() => {
          this.$store.state.loading.status = false;
        });
    },

    async DataQuery() {
      this.isLoading = true;

      this.$store.state.loading.msg = "Query Data...";
      this.$store.state.loading.status = true;
      await axios
        .post("report/attendance", {
          id_contract: localStorage.getItem("QUERY_ID"),
          month: this.filter_month,
          year: this.filter_year,
        })
        .then((response) => {
          let query = response.data;
          this.model_group_employee = query.employee;
          this.model_contract = query.contract;
          this.model_date_range = query.date_range;

          // reset
          this.total_employee = 0;
          this.model_inout = [];

          // total employee
          for (let key in this.model_group_employee) {
            this.total_employee++;
          }

          // in and out
          let m_employee = this.model_group_employee;
          for (let key in m_employee) {
            this.model_inout.push({
              index: key,
              res: "in",
            });
            this.model_inout.push({
              index: key,
              res: "out",
            });
          }

          // table width
          // console.log("table with cover => ", parseInt(this.model_date_range.length), parseInt(this.model_date_range.length) * 70)
          this.table_cover_width = parseInt(this.model_date_range.length) * 70;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.statusText);
        })
        .finally(() => {
          this.$store.state.loading.status = false;
        });
    },

    async Submit() {
      let model = {
        id_contract: this.model_contract.id,
        shift: this.model_group_employee,
      };
      let data = {
        url: this.meta_url + "/assign",
        callback_url: "jobcon/shift",
        form_data: model,
      };
      let res = await this.$store.dispatch("crud/storeData", data);
      if (res) {
        this.total_employee = 0;
        this.DataQuery();
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.attendance-detail-page { color: #344a58; }
.attendance-detail-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(45, 111, 145, .16);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 145px;
  overflow: hidden;
  padding: 25px 28px;
  position: relative;
}
.attendance-detail-hero::after {
  background: rgba(255,255,255,.08);
  border-radius: 50%;
  content: "";
  height: 210px;
  position: absolute;
  right: -55px;
  top: -95px;
  width: 210px;
}
.attendance-detail-hero__eyebrow { color: #c7f4eb; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; }
.attendance-detail-hero h2 { color: #fff; font-size: 24px; font-weight: 700; margin: 5px 0 6px; }
.attendance-detail-hero p { color: rgba(255,255,255,.82); margin: 0; }
.attendance-back-btn {
  align-items: center;
  background: rgba(255,255,255,.14);
  border: 1px solid rgba(255,255,255,.28);
  border-radius: 8px;
  color: #fff;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 7px;
  padding: 10px 13px;
  position: relative;
  z-index: 1;
}
.attendance-back-btn:hover { background: rgba(255,255,255,.22); color: #fff; }
.attendance-detail-card { border: 1px solid #e5ebf1; border-radius: 14px; box-shadow: 0 10px 28px rgba(41,72,105,.07); overflow: hidden; }
.attendance-detail-card > .card-body { padding: 26px; }
.contract-summary { background: #f7fafc; border: 1px solid #e1eaf0; border-radius: 11px; overflow: hidden; }
.contract-summary > .row { margin: 0; }
.contract-client { padding: 24px 26px; }
.contract-summary__label { color: #3193a7; font-size: 10px; font-weight: 700; letter-spacing: 1px; }
.contract-client h4 { color: #2c4655; font-size: 20px; font-weight: 700; margin: 6px 0 13px; }
.contract-contact { display: flex; flex-wrap: wrap; gap: 10px 22px; margin-bottom: 12px; }
.contract-contact span { align-items: center; color: #607783; display: inline-flex; gap: 7px; }
.contract-contact i, .contract-address > i { color: #3193a7; }
.contract-address { align-items: flex-start; color: #526b78; display: flex; gap: 8px; line-height: 1.6; margin: 0; }
.contract-facts { background: #edf6f8; border-left: 1px solid #dce9ed; padding: 12px 22px; }
ul.list-area { margin: 0; padding: 0; width: 100%; }
ul.list-area li { align-items: flex-start; border-bottom: 1px solid #dce8ec; display: flex; justify-content: space-between; list-style: none; padding: 11px 0; width: 100%; }
ul.list-area li:last-child { border-bottom: 0; }
ul.list-area li > span:first-child { color: #6a808c; font-size: 11px; font-weight: 600; padding-right: 12px; }
ul.list-area strong { color: #2f5365; font-size: 12px; max-width: 70%; text-align: right; }
.manpower-list { display: flex; flex-wrap: wrap; gap: 5px; justify-content: flex-end; max-width: 70%; }
.manpower-list span { background: #fff; border: 1px solid #d7e5e9; border-radius: 12px; color: #52707e; font-size: 10px; padding: 3px 7px; }
.attendance-toolbar { align-items: center; border-bottom: 1px solid #e6edf1; display: flex; justify-content: space-between; margin: 26px 0 18px; padding: 0 2px 18px; }
.attendance-toolbar__heading label { color: #2d5365; display: block; font-size: 14px; font-weight: 700; margin: 0 0 4px; }
.attendance-toolbar__heading label i { color: #3193a7; margin-right: 5px; }
.attendance-toolbar__heading small { color: #82949e; }
.attendance-toolbar__actions { align-items: center; display: flex; flex-wrap: wrap; gap: 8px; justify-content: flex-end; }
.attendance-toolbar__actions .btn { border-radius: 7px; margin: 0; }
.attendance-month-picker { min-width: 180px; }
.attendance-matrix { border: 1px solid #dfe8ed; border-radius: 10px; display: grid; grid-template-columns: 155px minmax(0, 1fr); overflow: hidden; }
.attendance-date-column { background: #f7fafc; border-right: 2px solid #d7e4e9; position: relative; z-index: 2; }
.attendance-employee-grid { min-width: 0; }
.attendance-table-cover { border: 0; margin: 0; overflow: auto; }
.attendance-date-column .attendance-table-cover { overflow: hidden; }
.attendance-table-cover table { border-collapse: collapse; margin: 0; width: 100%; }
.attendance-table-cover table thead tr > th { background: #eaf4f6; border-color: #dbe7eb; color: #4c6877; font-size: 11px; font-weight: 700; padding: 0 8px; white-space: nowrap; }
.attendance-date-column table { table-layout: fixed; width: 100%; }
.attendance-date-title b { color: #32788a !important; }
.attendance-table-cover tbody td { border-color: #e5ecef; color: #536c78; font-size: 11px; min-width: 78px; padding: 10px 8px; text-align: center; }
.attendance-date-column tbody td { background: #fbfcfd; min-width: 0; text-align: left; }
.attendance-table-cover tbody tr:hover td { background: #f1f9f9; }
.employee-download { color: #3193a7; font-size: 10px; font-weight: 600; }
.employee-download i { margin-right: 4px; }
.employee-name { color: #496978; font-size: 11px; font-weight: 600; }
.attendance-camera { color: #55a89d; }
.attendance-table-cover .badge { border-radius: 12px; font-size: 10px; padding: 5px 8px; }
.tdp { padding: 12px; }
.date-month { color: gray; position: absolute; top: -5px; }
.select-filter { background-color: transparent; border: none; color: #dc3545; height: 20px; width: 100%; }
.attendance-empty { align-items: center; background: #fbf7ec; border: 1px solid #f0dfb1; border-radius: 10px; display: flex; justify-content: center; min-height: 180px; padding: 25px; text-align: center; }
.attendance-empty i, .attendance-empty strong, .attendance-empty span { display: block; }
.attendance-empty i { color: #d99b28; font-size: 27px; margin-bottom: 10px; }
.attendance-empty strong { color: #775b25; font-size: 14px; margin-bottom: 4px; }
.attendance-empty span { color: #9a7a3e; font-size: 12px; }
.attendance-modal .content { border: 0; border-radius: 13px; box-shadow: 0 22px 60px rgba(13,42,57,.28); max-width: 560px; padding: 25px; }
.attendance-modal .content h5 { color: #2d4b5b; font-weight: 700; }
.attendance-modal .content hr { border-color: #e5ecef; }
.attendance-modal #close-popup { align-items: center; background: #edf4f6; border-radius: 50%; color: #67808d; display: flex; height: 32px; justify-content: center; right: 15px; top: 15px; width: 32px; }
.attendance-modal .btn { border-radius: 7px; }
.attendance-photo-modal .content { max-width: 760px; }
.attendance-photo-modal img { border-radius: 9px; box-shadow: 0 8px 25px rgba(32,57,70,.16); max-width: 100%; object-fit: contain; }
@media (max-width: 991px) {
  .attendance-toolbar { align-items: flex-start; flex-direction: column; gap: 15px; }
  .attendance-toolbar__actions { justify-content: flex-start; width: 100%; }
  .contract-facts { border-left: 0; border-top: 1px solid #dce9ed; }
}
@media (max-width: 767px) {
  .attendance-detail-hero { align-items: flex-start; flex-direction: column; padding: 22px 20px; }
  .attendance-back-btn { margin-top: 18px; width: 100%; }
  .attendance-detail-card > .card-body { padding: 15px; }
  .contract-client, .contract-facts { padding: 18px; }
  .contract-contact { align-items: flex-start; flex-direction: column; }
  ul.list-area li { flex-direction: column; gap: 6px; }
  ul.list-area strong, .manpower-list { justify-content: flex-start; max-width: 100%; text-align: left; }
  .attendance-toolbar__actions { align-items: stretch; flex-direction: column; }
  .attendance-toolbar__actions .btn, .attendance-month-picker { width: 100%; }
  .attendance-matrix { grid-template-columns: 112px minmax(0, 1fr); }
  .attendance-table-cover table thead tr > th { font-size: 10px; padding: 0 5px; }
  .attendance-table-cover tbody td { font-size: 10px; min-width: 74px; padding: 8px 5px; }
  .attendance-modal .content { max-height: calc(100vh - 30px); max-width: calc(100vw - 24px); overflow-y: auto; padding: 22px 18px; width: 100%; }
}
</style>
